<template>
    <!--
        https://animod.atlassian.net/browse/ANI-1223 Legal info section
    -->
    <div id="legalInfo">
        <div v-if="legalInfo.travelPackageDirectivePdfUrl" class="form-check">
            <input
                id="travelPackageDirectiveRead"
                class="form-check-input"
                name="travelPackageDirectiveRead"
                type="checkbox"
                placeholder="Richtlinie über Reisepakete"
                required
            />
            <!--Placeholder for the validation message-->
            <translate
                tag="label"
                path="Checkout.legalInfo.travelPackageDirective"
                class="form-check-label"
                for="travelPackageDirectiveRead"
            >
                <template v-slot:link>
                    <a :href="legalInfo.travelPackageDirectivePdfUrl" target="_blank" rel="nofollow noopener">
                        {{ $t('Checkout.legalInfo.travelPackageDirectiveLink') }}
                    </a>
                </template>
            </translate>
        </div>

        <div v-if="legalInfo.additionalLegalPdfText && legalInfo.additionalLegalPdfUrl" class="form-check">
            <input
                type="checkbox"
                id="additionalLegalPdfRead"
                class="form-check-input"
                placeholder="Zusätzlicher Gesetzlicher PDF-Text"
                required
            />
            <!--Placeholder for the validation message-->
            <label class="form-check-label" for="additionalLegalPdfRead">
                <a :href="legalInfo.additionalLegalPdfUrl" target="_blank" rel="nofollow noopener">
                    {{ legalInfo.additionalLegalPdfText }}
                </a>
            </label>
        </div>

        <div class="mb-2">
            <translate path="Checkout.legalInfo.terms">
                <nuxt-link slot="link0" :to="termsUrl" target="_blank">{{ $t('CheckoutFooter.agb') }}</nuxt-link>
                <nuxt-link slot="link1" :to="privacyUrl" target="_blank">{{ $t('DataProtection.link') }}</nuxt-link>
                <translate
                    v-if="legalInfo.termsAndConditionsUrl"
                    slot="optional"
                    path="Checkout.legalInfo.termsOptional"
                >
                    <template v-slot:link>
                        <a :href="legalInfo.termsAndConditionsUrl" target="_blank" rel="nofollow noopener">{{
                            $t('CheckoutFooter.agb')
                        }}</a>
                    </template>
                </translate>
            </translate>
            <span
                v-if="
                    showNewsletterTerms &&
                    legalInfo.newsletterEnabled &&
                    legalInfo.uwgTextVisible &&
                    legalInfo.newsletterOptInText &&
                    !legalInfo.platformTermsText
                "
            >
                {{ $t('Checkout.legalInfo.uwgNotice') }}
            </span>
            <span v-if="legalInfo.platformTermsText" v-html="legalInfo.platformTermsText"></span>

            <div
                v-if="showNewsletterTerms && legalInfo.newsletterEnabled && legalInfo.newsletterOptInText"
                class="mt-2 form-check"
            >
                <input
                    v-if="legalInfo.newsletterOptInRequired"
                    :value="newsletterAccepted"
                    type="checkbox"
                    class="form-check-input"
                    id="newsletterOptInRead"
                    @change="$emit('update:newsletterAccepted', $event.target.checked)"
                />
                <label
                    class="form-check-label"
                    for="newsletterOptInRead"
                    v-html="legalInfo.newsletterOptInText"
                ></label>
            </div>

            <span
                v-if="
                    showNewsletterTerms &&
                    legalInfo.newsletterEnabled &&
                    !legalInfo.newsletterOptInText &&
                    !legalInfo.platformTermsText
                "
            >
                {{ $t('Checkout.legalInfo.uwgNotice') }}
            </span>
        </div>


        <div v-if="legalInfo.additionalPlatformConsentVisible" class="form-check">
            <input
                type="checkbox"
                @change="$emit('update:additionalConsentGiven', $event.target.checked)"
                id="additionalPlatformConsentGiven"
                class="form-check-input"
                required
            />
            <label class="form-check-label" for="additionalPlatformConsentGiven">
                <translate path="Checkout.legalInfo.additionalPlatformConsentText">
                    <nuxt-link slot="privacyLink" :to="privacyUrl" target="_blank">{{ $t('Checkout.legalInfo.additionalPlatformConsentText.linkText') }}</nuxt-link>
                </translate>
            </label>
        </div>

        <p class="mb-0 phone-advice">
            {{ $t('Checkout.legalInfo.phoneSupport') }}:
            <a :href="'tel:' + supportPhoneNumber.replace(/\s/g, '')">{{ supportPhoneNumber }}</a>
        </p>
    </div>
</template>

<script>
export default {
    name: 'LegalInfo',
    props: {
        legalInfo: Object,
        newsletterAccepted: Boolean,
        showNewsletterTerms: Boolean
    },
    computed: {
        supportPhoneNumber() {
            return this.$store.state.globalMeta.supportPhoneNumber;
        },
        theme() {
            return this.$store.state.theme;
        },
        termsUrl() {
            return { name: 'category', params: { category: this.$t('CheckoutFooter.agb.url') || 'agb' } };
        },
        privacyUrl() {
            return {
                name: 'category',
                params: { category: this.$t('CheckoutFooter.privacyProtection.url') || 'datenschutz' }
            };
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';

#legalInfo {
    font-size: 12px;
    color: var(--muted-accessible, variables.$muted);

    .agb-lock-icon {
        width: 20px;
        height: 20px;
        color: black;
    }

    p {
        margin-bottom: 10px;
    }
}
</style>
